import React, { useState } from "react";
import { Flex } from "../tips.styled";
import { Color } from "config/colors";
import Modal from "@material-ui/core/Modal";
import { useTranslation } from "react-i18next";
import { Text } from "components/Typography/text.styled";
import { ButtonStyled } from "components/buttons/buttons.styled";
import { CustomIcon } from "components/icon/customIcon.component";
import { LinkWrapper, ModalBody } from "./alertModal.styled";

type AlertModaProps = {
  children: (
    openAlertModal: (
      text: string | React.ReactNode,
      showCancel?: boolean,
      onConfirm?: (close: () => void) => void,
      confirmText?: string,
      onSecondaryConfirm?: (close: () => void) => void,
      secondaryConfirmText?: string
    ) => void
  ) => React.ReactNode;
};

export const AlertModal: React.FC<AlertModaProps> = ({ children }) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState<string | React.ReactNode>(
    ""
  );
  const [showCancelButton, setShowCancelButton] = useState(false);
  const [primaryAction, setPrimaryAction] = useState<
    ((close: () => void) => void) | null
  >(null);
  const [secondaryAction, setSecondaryAction] = useState<
    ((close: () => void) => void) | null
  >(null);
  const [primaryButtonText, setPrimaryButtonText] = useState<
    string | undefined
  >();
  const [secondaryButtonText, setSecondaryButtonText] = useState<
    string | undefined
  >();

  const closeModal = () => setIsModalOpen(false);

  const openAlertModal = (
    message: string | React.ReactNode,
    showCancel = false,
    onConfirm?: (close: () => void) => void,
    confirmText?: string,
    onSecondaryConfirm?: (close: () => void) => void,
    secondaryText?: string
  ) => {
    setModalMessage(message);
    setShowCancelButton(showCancel);
    setPrimaryAction(() => onConfirm || null);
    setSecondaryAction(() => onSecondaryConfirm || null);
    setPrimaryButtonText(confirmText);
    setSecondaryButtonText(secondaryText);
    setIsModalOpen(true);
  };

  return (
    <>
      {children(openAlertModal)}
      <Modal open={isModalOpen} onClose={closeModal}>
        <ModalBody>
          <LinkWrapper>
            <CustomIcon
              color={Color.LighterDestructive}
              onClick={closeModal}
              name={"cross"}
            >
              {t("General.Close")}
            </CustomIcon>
          </LinkWrapper>
          <Text style={{ display: "flex", justifyContent: "center" }}>
            {modalMessage}
          </Text>
          <Flex>
            <ButtonStyled
              backgroundColor={Color.ModernGreen}
              onClick={() => {
                if (primaryAction) primaryAction(closeModal);
                else closeModal();
              }}
            >
              {t(primaryButtonText || "General.Ok")}
            </ButtonStyled>

            {showCancelButton && (
              <ButtonStyled
                isCancel
                backgroundColor={Color.LighterDestructive}
                onClick={() => {
                  if (secondaryAction) secondaryAction(closeModal);
                  else closeModal();
                }}
              >
                {t(secondaryButtonText || "General.Abort")}
              </ButtonStyled>
            )}
          </Flex>
        </ModalBody>
      </Modal>
    </>
  );
};
